import { SelectOption } from '../../UI/MainSelect/mainSelect.types';
import { StyledStatus } from './promoCodesFilters.styles';

export const formatOptionLabel = ({ value }: SelectOption) => (
  <StyledStatus enumName="promo-code-status" status={value} />
);
